import { hasFeature } from '@/services/featureService';
import { isBillingTeamSupervisor, isInAnyTeam, isSupervisor } from '@/services/userService';
import { useUserStore } from '@/stores/user';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  element: React.ReactElement;
  roles: string[];
  teamKeys?: string[];
  requiredFeature?: string;
  allowSupervisor?: boolean;
  allowBillingSupervisor?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  roles,
  teamKeys,
  requiredFeature,
  allowSupervisor,
  allowBillingSupervisor,
}) => {
  const userStore = useUserStore((state) => state.user);
  const userRole = userStore?.roleId;

  if (!userStore) return <Navigate to="/login" />;

  const hasRoleAccess =
    (!!userRole && roles?.includes(userRole)) ||
    (!!teamKeys?.length && isInAnyTeam(userStore, teamKeys)) ||
    (!!allowSupervisor && isSupervisor(userStore)) ||
    (!!allowBillingSupervisor && isBillingTeamSupervisor(userStore));

  if (!hasRoleAccess) {
    return <Navigate to="/not-found" />;
  }

  if (requiredFeature && !hasFeature(requiredFeature)) {
    return <Navigate to="/not-found" />;
  }

  return element;
};
